/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RouterMatchPropTypeBuilder } from 'app/utils/propTypes/common';
import TaskRoute from 'app/containers/Abox/TaskView/TaskRoute';
import PageNotAllowed from 'app/containers/ErrorPages/PageNotAllowed';
import { connect } from 'react-redux';

/**
 * Define the routes for the Abox Task's views.
 */
class TaskViewRoute extends PureComponent {
    static propTypes = {
        match: RouterMatchPropTypeBuilder({ id: PropTypes.string }),
    };

    /**
     * @override
     */
    render() {
        const { match, userProfile, clientConfig } = this.props;
        
        const { permissions, isAdmin } = userProfile;
        const permissionsSet = new Set(permissions || []);
        const hasPermission = isAdmin || permissionsSet.has('abox.task');
        
        if (!hasPermission && !clientConfig.showTaskPage) {
            return <PageNotAllowed title="Tasks" />;
        }
        
        return (
            <Switch>
                <Route path={`${match.url}/`} exact component={() => <Redirect to="/abox/tasks" />} />
                <Route path={`${match.url}/:id`} component={TaskRoute} />
            </Switch>
        );
    }
}

export default connect((state, ownProps) => ({
    userProfile: state.user.profile,
    clientConfig: state.app.clientConfig.data,
}))(TaskViewRoute);
